export const dpmoApiUrl = "https://dpmo-colab-v1.dpmo.eu/";

// export const dpmoApiUrl = "http://localhost:8090/";
